<template>
  <v-container
    id="users-list"
    tag="section"
  >
    <!-- Toast de réussite ou d'échec -->
    <!--<v-snackbar
      v-model="msg.alert"
      top
      shaped
      :color="msg.type"
      :timeout="msg.timeout"
    >
      <v-icon left>
        {{ msg.icon }}
      </v-icon>
      {{ msg.msg }}

      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="msg.alert = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>-->
    <v-row justify="center">
      <v-col cols="8">
        <timed-alert
          :display="msg.alert"
          :msg="msg.msg"
          :type="msg.type"
        />
      </v-col>
    </v-row>

    <base-material-card
      color="primary"
      icon="mdi-briefcase-variant"
      inline
      class="px-5 py-3"
    >
      <template v-slot:heading>
        <div class="display-2 font-weight-light">
          <v-icon left>
            mdi-briefcase-variant
          </v-icon>
          {{ title }}
        </div>
      </template>

      <!-- **************** ***
      ****      MODALS      ***
      **** **************** -->
      <!-- Modal de création d'utilisateur -->
      <template v-slot:after-heading>
        <v-dialog
          v-model="addDialog"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              outlined
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left>
                mdi-plus
              </v-icon>
              Ajouter un utilisateur
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline secondary--text">Nouveau utilisateur</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <!-- Formulaire -->
                <v-form
                  ref="addForm"
                  v-model="addIsValid"
                >
                  <v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="addedItem.name"
                          :rules="[rules.required]"
                          label="Nom de l'utilisateur..."
                          prepend-icon="mdi-account-tie"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          v-model="addedItem.companyId"
                          item-value="id"
                          item-text="name"
                          :rules="[rules.required]"
                          :items="companies"
                          label="Société..."
                          prepend-icon="mdi-account-group"
                        />
                      </v-col>
                      <v-select
                        v-model="addedItem.roleId"
                        item-value="id"
                        item-text="role"
                        :rules="[rules.required]"
                        :items="roles"
                        label="Role..."
                        prepend-icon="mdi-account-group"
                      />
                      <v-col cols="12">
                        <v-text-field
                          v-model="addedItem.email"
                          :rules="[rules.required, rules.minLength]"
                          label="Email"
                          prepend-icon="mdi-email"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="addedItem.password"
                          label="Mot de passe"
                          :rules="[rules.required, rules.minLength]"
                          prepend-icon="mdi-lock"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          v-model="addedItem.active"
                          :items="activeValues"
                          label="Active"
                          prepend-icon="mdi-check"
                        />
                      </v-col>
                    </v-row>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="success darken-1"
                text
                :disabled="!addIsValid"
                @click="addItem()"
              >
                Créer
              </v-btn>
              <v-btn
                color="error darken-1"
                text
                @click="addDialog = false"
              >
                Annuler
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <!-- Modal de modification d'utilisateur -->
      <v-dialog
        v-model="editDialog"
        persistent
        max-width="500px"
      >
        <v-card>
          <!-- Création des onglets (navigation) pour le formulaire de modification -->
          <v-tabs
            v-model="editTab"
            background-color="secondary accent-4"
            dark
            grow
            icons-and-text
          >
            <v-tab key="#tab-1">
              Informations
              <v-icon>mdi-account</v-icon>
            </v-tab>
          </v-tabs>

          <!-- Création des onglets (contenu) pour le formulaire de modification -->
          <v-tabs-items v-model="editTab">
            <v-tab-item key="#tab-1">
              <v-card-title>
                <span class="headline secondary--text">Modification de l'utilisateur<br><b>{{ editedItem.name }}</b></span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <!-- Formulaire -->
                  <v-form
                    ref="editForm"
                    v-model="editIsValid"
                  >
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.name"
                          :rules="[rules.required]"
                          label="Nom de l'utilisateur..."
                          prepend-icon="mdi-account-tie"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          v-model="editedItem.companyId"
                          item-value="id"
                          item-text="name"
                          :rules="[rules.required]"
                          :items="companies"
                          label="Société..."
                          prepend-icon="mdi-account-group"
                        />
                      </v-col>
                      <v-select
                        v-model="editedItem.roleId"
                        item-value="id"
                        item-text="role"
                        :rules="[rules.required]"
                        :items="roles"
                        label="Role..."
                        prepend-icon="mdi-account-group"
                      />
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.email"
                          :rules="[rules.required, rules.minLength]"
                          label="Email"
                          prepend-icon="mdi-email"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.password"
                          label="Mot de passe"
                          prepend-icon="mdi-lock"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          v-model="editedItem.active"
                          :items="activeValues"
                          label="Active"
                          prepend-icon="mdi-check"
                        />
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="success darken-1"
                  text
                  :disabled="!editIsValid"
                  @click="editItem()"
                >
                  Modifier
                </v-btn>
                <v-btn
                  color="error darken-1"
                  text
                  @click="editDialog = false"
                >
                  Annuler
                </v-btn>
              </v-card-actions>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-dialog>

      <!-- Modal de suppression d'entreprise -->
      <v-dialog
        v-model="deleteDialog"
        persistent
        max-width="400"
      >
        <v-card>
          <v-card-title class="headline">
            Êtes-vous sûr de vouloir<br>supprimer cet élément ?
          </v-card-title>
          <v-card-text>
            <!-- Récapitulatif des informations -->
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="deletedItem.name"
                  label="Nom..."
                  prepend-icon="mdi-account-tie"
                  readonly
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="deletedItem.id"
                  label="Identifiant..."
                  prepend-icon="mdi-card-account-details"
                  readonly
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="deletedItem.companyId"
                  label="ID entreprise..."
                  prepend-icon="mdi-account-group"
                  readonly
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="success darken-1"
              text
              @click="deleteItem()"
            >
              Supprimer
            </v-btn>
            <v-btn
              color="error darken-1"
              text
              @click="deleteDialog = false"
            >
              Annuler
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- **************** ***
      ****      TABLE      ***
      **** **************** -->
      <!-- Champ de recherche dans la table -->
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Rechercher"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :sort-by="['id']"
        :sort-desc="[false]"
        :loading="isLoading"
        :items-per-page="Number(50)"
        multi-sort
      >
        <!-- Définition de l'action d'édition -->
        <template v-slot:item.edit="{ item }">
          <v-row justify="space-around">
            <!-- Modification des infos -->
            <v-icon
              class="success--text"
              @click="prepareEditItem(item, 0)"
            >
              mdi-pencil
            </v-icon>
          </v-row>
        </template>

        <!-- Définition de l'action de suppression -->
        <template v-slot:item.delete="{ item }">
          <v-row justify="center">
            <v-icon
              class="error--text"
              @click="prepareDeleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </v-row>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import TimedAlert from '../alerts/TimedAlert.vue'
  import moment from 'moment'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'UsersList',

    /* Sous-composants utilisés par ce composant */
    components: {
      TimedAlert,
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: () => ({
      title: 'Utilisateurs',
      isLoading: true,

      companies: [],
      roles: [],
      activeValues: [
        {
          value: 0,
          text: 'Desactivé',
        },
        {
          value: 1,
          text: 'Activé',
        },
      ],

      // Variables pour les formulaires de création / modification / suppression
      rules: {
        minLength: value => (!!value && (value.length >= 4)) || 'Ce champ contient 4 caractères minimum.',
        required: value => !!value || 'Ce champ ne peut être vide.',
      },

      addDialog: false,
      addIsValid: true,
      addedItem: {
        name: '',
        companyCode: '',
        endOfAccessAt: new Date(),
      },

      editDialog: false,
      editIsValid: true,
      editPictureIsValid: true,
      editTab: null,
      editNewPicture: null,
      editedItem: {
        id: undefined,
        name: undefined,
        companyCode: undefined,
        endOfAccessAt: undefined,
      },

      deleteDialog: false,
      deletedItem: {
        id: undefined,
        name: undefined,
        companyCode: undefined,
        endOfAccessAt: undefined,
        picture: undefined,
        worlds: undefined,
      },

      // Message de réussite ou d'échec des actions
      msg: {
        alert: false,
        msg: '',
        timeout: 5000,
        type: 'success',
      },

      // Variables relatives au tableau de données
      headers: [
        {
          text: '#',
          value: 'id',
        },
        {
          text: 'Société',
          value: 'companyName',
        },
        {
          text: 'Nom',
          value: 'name',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Rôle',
          value: 'role',
        },
        {
          text: 'Nombre de connections',
          value: 'nbOfConnection',
        },
        {
          text: 'Active',
          value: 'active',
        },
        {
          text: 'Date de création',
          value: 'createdAt',
        },
        {
          sortable: false,
          text: 'Éditer',
          value: 'edit',
        },
        {
          sortable: false,
          text: 'Supprimer',
          value: 'delete',
        },
      ],
      items: [],
      search: undefined,
    }),

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    computed: {
      formattedDeletedDate () {
        return this.formatDate(this.deletedItem.createdAt)
      },
    },

    /* Hook : fonction appelée juste après que l’instance ait été montée */
    mounted: function () {
      this.fetchUsers()
      this.fetchCompanies()
      this.fetchRoles()
    },

    /* Fonctions internes */
    methods: {
      // Récupération des données des utilisateurs
      fetchUsers: function () {
        this.isLoading = true
        const url = this.id ? '/' + this.id : ''
        this.$Auth.httpRequest(
          'get',
          'api/user/selectUsers' + url,
        )
          .then(datas => {
            if (
              !Array.isArray(datas.data) ||
              (Array.isArray(datas.data) && datas.data.length < 1)
            ) {
              this.items = []
              this.isLoading = false
              return
            }
            this.items = datas.data
          })
          .catch((/* error */) => {
            this.items = []
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.isLoading = false
          })
      },

      // Récupération des données des entreprises
      fetchCompanies: function () {
        this.isLoading = true
        const url = this.id ? '/' + this.id : ''
        this.$Auth.httpRequest(
          'get',
          'api/company/selectCompanies' + url,
        )
          .then(datas => {
            if (
              !Array.isArray(datas.data) ||
              (Array.isArray(datas.data) && datas.data.length < 1)
            ) {
              this.companies = []
              this.isLoading = false
              return
            }
            this.companies = datas.data
          })
          .catch((/* error */) => {
            this.companies = []
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.isLoading = false
          })
      },

      // Récupération des données des entreprises
      fetchRoles: function () {
        this.isLoading = true
        const url = this.id ? '/' + this.id : ''
        this.$Auth.httpRequest(
          'get',
          'api/role/selectRoles' + url,
        )
          .then(datas => {
            if (
              !Array.isArray(datas.data) ||
              (Array.isArray(datas.data) && datas.data.length < 1)
            ) {
              this.roles = []
              this.isLoading = false
              return
            }
            this.roles = datas.data
          })
          .catch((/* error */) => {
            this.roles = []
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.isLoading = false
          })
      },

      // Route l'application vers la liste des mondes pour une entreprise
      routeToCompanyWorlds: function (item) {
        this.$router.push({
          name: 'Company Worlds List',
          params: {
            idCompany: item.id.toString(),
            nameCompany: item.name,
          },
        })
      },

      /* ****************************** **
      /** Fonctions relatives aux dates **
      /** ***************************** */
      getDateMysql: function (date) {
        if (date != null) {
          date = new Date(date)
          const tmpDate = date
          // pour prendre en compte le timezeoneOffset (sinon ça met des dates mauvaises j-1)
          tmpDate.setHours(0, -date.getTimezoneOffset(), 0, 0)
          return tmpDate.toISOString().slice(0, 10) + ' 00:00:00'
        }
        return ''
      },

      formatDate: function (date) {
        return date ? moment(date).format('L') : ''
      },

      /* ********************************* **
      /** Fonctions relatives aux messages **
      /** ******************************** */
      /* Setter de message de réussite */
      setMsgSuccess: function (msg) {
        this.msg.msg = msg
        this.msg.alert = true
        this.msg.type = 'success'
        this.msg.icon = 'mdi-checkbox-marked-circle-outline'
      },

      /* Setter de message d'échec */
      setMsgError: function (msg) {
        this.msg.msg = msg
        this.msg.alert = true
        this.msg.type = 'error'
        this.msg.icon = 'mdi-error-outline'
      },

      /* ******************************* **
      /** Fonctions d'ajout d'entreprise **
      /** ****************************** */
      addItem: function () {
        // On définie l'état en chargement
        this.isLoading = true
        this.addDialog = false
        this.msg.alert = false

        // Ajout d'une entreprise
        this.$Auth.httpRequest('post', 'api/user/insert', {
          companyId: this.addedItem.companyId,
          name: this.addedItem.name,
          email: this.addedItem.email,
          password: this.addedItem.password,
          active: this.addedItem.active,
          roleId: this.addedItem.roleId,
        })
          .then(datas => {
            // Affichage de la confirmation
            this.setMsgSuccess('L\'utilisateur a été créé avec succès.')

            // Réinitialisation des valeurs pour l'item ajouté
            this.addedItem.companyId = ''
            this.addedItem.roleId = ''
            this.addedItem.name = ''
            this.addedItem.email = ''
            this.addedItem.password = ''
            this.addedItem.active = ''
          })
          .catch((/* error */) => {
            // Affichage de l'erreur
            this.setMsgError('Erreur lors de la création de l\'utilisateur.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.$refs.addForm.resetValidation()
            this.isLoading = false
            this.fetchUsers()
          })
      },

      /* *************************************** **
      /** Fonctions de modification d'entreprise **
      /** ************************************** */
      prepareEditItem: function (item, tab) {
        // Redirection vers le bon onglet
        // 0 pour l'onglet Informations
        // 1 pour l'onglet Logo
        this.editTab = tab

        // Création du clone d'item
        this.editedItem = { ...item }
        this.editDialog = true
      },

      resetEditedItem: function () {
        return {
          id: undefined,
          name: undefined,
          companyCode: undefined,
          endOfAccessAt: undefined,
        }
      },

      editItem: function () {
        // On définie l'état en chargement
        this.isLoading = true
        this.editDialog = false
        this.msg.alert = false

        // Modification de l'entreprise
        this.$Auth.httpRequest('post', 'api/user/update', {
          companyId: this.editedItem.companyId,
          name: this.editedItem.name,
          email: this.editedItem.email,
          password: this.editedItem.password,
          active: this.editedItem.active,
          userId: this.editedItem.id,
          roleId: this.editedItem.roleId,
        })
          .then(datas => {
            // Affichage de la confirmation
            this.setMsgSuccess('L\'utilisateur a été modifié avec succès.')
          })
          .catch((error) => {
            // Affichage de l'erreur
            this.setMsgError('Erreur lors de la modification de l\'utilisateur.')
            if (this.$Auth.isAdmin()) {
              // eslint-disable-next-line no-console
              console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.$refs.editForm.reset()
            this.editedItem = this.resetEditedItem()
            this.isLoading = false
            this.fetchUsers()
          })
      },

      /* ************************************** **
      /** Fonctions de suppression d'entreprise **
      /** ************************************* */
      prepareDeleteItem: function (item) {
        // Création du clone d'item
        this.deletedItem = { ...item }
        this.deleteDialog = true
      },

      deleteItem: function () {
        // On définie l'état en chargement
        this.isLoading = true
        this.deleteDialog = false
        this.msg.alert = false

        //  Suppression d'une entreprise
        this.$Auth.httpRequest('delete', 'api/user/deleteFullAdmin', {
          userId: this.deletedItem.id,
        })
          .then(datas => {
            // Affichage de la confirmation
            this.setMsgSuccess('L\'utilisateur a été supprimé avec succès.')
          })
          .catch((/* error */) => {
            // Affichage de l'erreur
            this.setMsgError('Erreur lors de la suppression de l\'utilisateur.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.isLoading = false
            this.fetchUsers()
          })
      },
    },
  }
</script>
